export enum HttpErrors {
  BadRequest = 400,
  UnprocessableEntity = 422,
}
